import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      gcTime: 10 * 60_000,
      refetchOnWindowFocus: false,
      retry: (n, err) => {
        if (err instanceof ApiError && (err.isAuthError || err.status === 404)) return false;
        return n < 2;
      },
    },
    mutations: { retry: false },
  },
});
